import { rankings } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 tracking-wide">热度榜单</h2>
          <p className="mt-2 text-sm text-foreground-500">本周最受关注的影视作品排名，口碑与热度兼具</p>
        </div>
        <div className="max-w-2xl mx-auto">
          {rankings.map((item) => {
            const isTop = item.rank <= 3;
            return (
              <div
                key={item.rank}
                className={`flex items-center gap-4 py-4 px-4 border-b border-background-200 last:border-b-0 cursor-pointer hover:bg-background-50/50 transition-colors rounded-md group ${
                  isTop ? '' : ''
                }`}
              >
                <div
                  className={`w-9 h-9 flex items-center justify-center rounded-md flex-shrink-0 font-heading text-base ${
                    item.rank === 1
                      ? 'bg-primary-500 text-white'
                      : item.rank === 2
                      ? 'bg-primary-500/80 text-white'
                      : item.rank === 3
                      ? 'bg-primary-500/60 text-white'
                      : 'bg-background-200 text-foreground-400'
                  }`}
                >
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground-700 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                    {item.title}
                  </p>
                  <p className="text-xs text-foreground-400 mt-0.5">{item.genre}</p>
                </div>
                <div className="flex items-center gap-4 flex-shrink-0">
                  <span className="text-sm font-semibold text-secondary-400 font-heading">{item.score}</span>
                  <span className="text-xs text-foreground-400">{item.views}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}